import { Link } from "react-router-dom";

const PointsFilter = ({ setShowFilterModal, setData, response, selectedPoints, setSelectedPoints }) => {

    const pointsOptions = [
        { id: 1, label: "0 - 5L", value: "0-500000" },
        { id: 2, label: "5L - 10L", value: "500001-1000000" },
        { id: 3, label: "10L - 20L", value: "1000001-2000000" },
        { id: 4, label: "20L - 30L", value: "2000001-3000000" },
        { id: 5, label: "30L - 50L", value: "3000001-5000000" },
        { id: 6, label: "50L+", value: "5000000+" }
    ];

    const handleCheckboxChange = (value) => {
        setSelectedPoints((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };

    const handleFilter = () => {
        if (selectedPoints.length === 0) {
            setData(response);
            setShowFilterModal(false)
            return;
        }

        const filteredData = response?.filter((item) => {
            const value = Number(item.voucherValue * 100);

            return selectedPoints.some((range) => {
                if (range === "5000000+") {
                    return value >= 5000000;
                }

                const [min, max] = range.split("-").map(Number);
                return value >= min && value <= max;
            });
        });

        setData(filteredData);
        setShowFilterModal(false)
    };

    return (
        <div class="popup show" id="transactions_box">
            <div class="popup-transactionBox">
                <div class="popup-transactionBox-inner">
                    <div class="popup-transactionBox-inner-header">
                        <h4>Filters</h4>
                        <Link to="" onClick={() => setShowFilterModal(false)} class="close-popup">X</Link>
                    </div>
                    <div className="popup-transactionBox-inner-body">
                        <div className="points-filter-box">
                            {pointsOptions.map((option) => (
                                <div key={option.id} className="checkbox-item">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value={option.value}
                                            checked={selectedPoints.includes(option.value)}
                                            onChange={() => handleCheckboxChange(option.value)}
                                        />
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="popup-transactionBox-inner-bottom">
                        <div className='popup-transactionBox-inner-bottom-inner'>
                            <button onClick={() => handleFilter()}>Apply</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PointsFilter;